class FirehawkCRMCartGrid {

  cartId = null
  listElement = null
	loadingOverlay = null
  cartSummary = null

  categoryId = null

	totalPages = 0
	totalItems = 0
	page = -1
	pageSize = 16

	searchRequest = null

	team = null

	pageItems = []

	defaultImageUrl = null
	currentLocation = null

	query = null

	dateLocale = null

	startDate = null
	endDate = null
	sortByService = false
  	stockSlug = null

	constructor(cartId, element, cartSummary) {
    this.cartId = cartId && cartId.length ? cartId : null
		this.listElement = element
    this.cartSummary = cartSummary;

		this.loadingOverlay = jQuery(`<div class="loading-overlay"><i class="far fa-spinner-third fa-spin"></i></div>`)
		this.listElement.addClass("loading")
		this.listElement.append(this.loadingOverlay)
		this.addListeners()
	}

	buildItem(item) {
		let displayImageView = ""

		var displayImage = item.displayImage || this.defaultImageUrl
		if (displayImage && displayImage.length) {
			displayImageView = `<div class="fh-cart-stock-image" style="background-image: url('${displayImage}')"></div>`
		} else {
			displayImageView = '<div class="fh-cart-stock-image placeholder" style="background: #f1f1f1;"></div>';
		}
		var permalink = null

    let price = item.price;

    let meta = "";
    if(item.meta) {
      let metaKeys = Object.keys(item.meta);
      for (var i = 0; i < metaKeys.length; i++) {
        meta = `${meta}<div class="fh-cart-stock-meta"><span class="fh-card-stock-meta-title">${item.meta[metaKeys[i]].label}:</span> <span class="fh-card-stock-meta-value">${item.meta[metaKeys[i]].value}</span></div>`
      }
    }

    var stockName = item.name

    if (this.stockSlug) {
      if (item.parentStockId) {
        stockName = `<a href="/${this.stockSlug}/?stock=${item.parentStockId}&variant=${item.id}">${item.name}</a>`
      } else {
        stockName = `<a href="/${this.stockSlug}/?stock=${item.id}">${item.name}</a>`
      }
    }

		var content = `
    <div class="fh-cart-items">
      <div class="fh-cart-stock-row" data-stock="${item.id}">
        <div class="fh-cart-stock-column fh-cart-stock-image-column">
          ${displayImageView}
        </div>
        <div class="fh-cart-stock-column fh-cart-column-padding fh-cart-column-content ps-4 me-auto">
          <div class="fh-cart-stock-name">${stockName}</div>
          <div class="fh-cart-stock-code">${item.stockCode}</div>
          ${meta}
        </div>
        <div class="fh-cart-stock-column fh-cart-column-padding fh-cart-column-content fh-cart-quantity-column">
          <div class="fh-cart-stock-quantity">
            <div class="input-group quantity-picker">
              <button class="btn btn-primary subtract-button input-group-prepend" type="button">-</button>
              <label class="form-control text-center quantity-value" aria-label="Quantity">${item.quantity}</label>
              <button class="btn btn-primary add-button input-group-append" type="button">+</button>
            </div>
          </div>
        </div>
        <div class="fh-cart-stock-column fh-cart-column-padding fh-cart-column-padding fh-cart-column-content text-right px-4">
          <div class="fh-cart-stock-price">Per Unit: ${price}</div>
          <div class="fh-cart-stock-total-price">Total: ${item.totalPrice}</div>
        </div>
      </div>
    </div>
		`
		return content
	}

	buildEntityListView(items) {
		var gridItems = ""
		for (let item of items) {
			var view = this.buildItem(item)
			gridItems += `${view}`
		}

		let content = `${gridItems}`

		jQuery(this.listElement).html(content)
	}

	addListeners() {

		jQuery(this.listElement).delegate(".grid-item", "click", (event) => {
			const contentLink = jQuery(event.currentTarget).data("link")
			if (contentLink) {
				if (event.ctrlKey || event.metaKey) {
					window.open(contentLink, "_blank")
				} else {
					document.location = contentLink
				}
			}
		})

		jQuery(this.listElement).delegate(".grid-item", "keypress", (event) => {
			const contentLink = jQuery(event.currentTarget).data("link")
			if (event.which == 13 && contentLink) {
				document.location = contentLink
			}
		})

    jQuery(this.listElement).delegate(".subtract-button", 'click', (event) => {
			event.preventDefault()
			var current = jQuery(event.currentTarget);
      var stockRow = jQuery(current).closest(".fh-cart-stock-row")
      let stockId = stockRow.data("stock");
      this.removeFromCart(stockId);

      // Subtract quantity value
      let quantityField = stockRow.find(".quantity-picker .quantity-value")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }

      quantity -= 1

      if (quantity <= 0) {
        stockRow.remove()
      } else {
        quantityField.text(quantity)
      }
		});

    jQuery(this.listElement).delegate(".add-button", 'click', (event) => {
			event.preventDefault()
      var current = jQuery(event.currentTarget);
      var stockRow = jQuery(current).closest(".fh-cart-stock-row")
      let stockId = stockRow.data("stock");
      this.addToCart(stockId);

      // Add quantity value
      let quantityField = stockRow.find(".quantity-picker .quantity-value")
      let quantity = quantityField.text()
      if (!quantity) {
        quantity = 1
      } else {
        quantity = +quantity
      }

      quantity += 1
      quantityField.text(quantity)
		});

	}

  addToCart(stock) {
    var params = {
			stock: stock,
      cart: this.cartId
		};

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'add_to_cart',
				params: params
			}
		}).done((response) => {
      this.reloadView(0);
		}).fail(() => {

	  })
	}

  removeFromCart(stock) {
    var params = {
			stock: stock,
      cart: this.cartId
		};

		jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'remove_from_cart',
				params: params
			}
		}).done((response) => {
      this.reloadView(0);
		}).fail(() => {

	  })
	}

	getEvent(eventId) {
		if (!eventId || !eventId.length) return null
		return this.pageItems.filter(e => e.id == eventId)[0]
	}

	getEntities(from) {
		this.listElement.addClass("loading")
		this.listElement.append(this.loadingOverlay)

		var params = {
      cart: this.cartId
    };

		var page = ((from || 0) / this.pageSize) || 0
		this.page = page

		if (this.searchRequest) {
			this.searchRequest.abort()
		}

		this.searchRequest = jQuery.ajax({
			method: 'post',
			url: ajax_var.url,
			data: {
				action: 'get_cart_stock',
				params: params
			}
		}).done((response) => {
			var results = []
			var total = 0

			if (response) {
				var data = JSON.parse(response);
				if (data && data.stock) {
					results = data.stock

          let subtotal = data.subtotal || 0
          let tax = data.tax || 0
          let total = data.total || 0
          jQuery(this.cartSummary).find('#fh-cart-balance-subtotal').html(subtotal)
          jQuery(this.cartSummary).find('#fh-cart-balance-tax').html(tax)
          jQuery(this.cartSummary).find('#fh-cart-balance-total').html(total)
				}
			}

			this.pageItems = results

			this.buildEntityListView(results)

			if (!results.length) {
				this.showEmptyListView()
			}
		}).fail(() => {
			this.loadingOverlay.hide()
			this.listElement.removeClass("loading")
	  })

	}

	showEmptyListView() {
		let emptyView = jQuery(`<div class="empty-view">Your cart is empty</div>`)
		jQuery(this.listElement).html(emptyView)
	}

	reloadView(from, query = null, startDate = null, endDate = null) {
		this.query = query
		this.startDate = startDate
		this.endDate = endDate
		this.getEntities(from)
	}

	search(query) {
		this.query = query
		this.getEntities(0)
	}

	setupView(size) {
		this.pageSize = size ? +size : 16
		this.reloadView(0)
	}

}
